import { createSlice } from "@reduxjs/toolkit"

const filterSlice = createSlice({
    name: "filter",
    initialState: {
        selected: "All",
    },
    reducers: {
        setFilter: (state, action) => {
            state.selected = action.payload
        },
    },
})

export const { setFilter } = filterSlice.actions
export default filterSlice.reducer
